export type NavLinks = {
  at: { name: string, link: string }[],
  br: { name: string, link: string }[],
  brfs: { name: string, link: string }[]
  gap: { name: string, link: string }[],
  gapfs: { name: string, link: string }[],
  on: { name: string, link: string }[]
};

const navLinks: NavLinks = {
  at: [
    { name: 'New Arrivals', link: '/browse/category.do?cid=1006482' },
    { name: "Women's Bottoms", link: '/browse/category.do?cid=1025878' },
    { name: 'All Activities', link: '/browse/category.do?cid=1112011' },
    { name: "Women's Workout Tops", link: '/browse/category.do?cid=1032080' },
    { name: 'Sports Bras', link: '/browse/category.do?cid=1038916' },
    { name: 'Swimsuits & Swimwear', link: '/browse/category.do?cid=1031353' },
    { name: 'Casual Dresses', link: '/browse/category.do?cid=89745' },
    { name: "Women's Jackets", link: '/browse/category.do?cid=1017102' },
    { name: 'Performance Accessories', link: '/browse/category.do?cid=1032096' },
    { name: "Girls' Activewear", link: '/browse/category.do?cid=1067955' },
    { name: 'Shop Sale Activewear', link: '/browse/category.do?cid=1023728' }
  ],
  br: [
    { name: "Women's Clothing", link: '/browse/division.do?cid=5002' },
    { name: "Men's Clothing", link: '/browse/division.do?cid=5343' },
    { name: "Women's Petite Clothing", link: '/browse/division.do?cid=5122' },
    { name: 'Shop Clothes on Sale', link: '/browse/division.do?cid=1014329' }
  ],
  brfs: [
    { name: 'Women’s Apparel', link: '/browse/category.do?cid=1145487' },
    { name: 'Men’s Apparel', link: '/browse/category.do?cid=1145413' },
    { name: 'Clearance', link: '/browse/division.do?cid=1044622' }
  ],
  gap: [
    { name: "Women's Clothing", link: '/browse/division.do?cid=5643' },
    { name: 'Maternity Clothing', link: '/browse/division.do?cid=5997' },
    { name: "Men's Clothing", link: '/browse/division.do?cid=5063' },
    { name: "Girls' Clothing", link: '/browse/division.do?cid=1137865' },
    { name: "Boys' Clothing", link: '/browse/division.do?cid=1137867' },
    { name: "Kid's Clothing", link: '/browse/division.do?cid=6170' },
    { name: 'Toddler Clothing', link: '/browse/division.do?cid=1137868' },
    { name: 'Baby Clothing', link: '/browse/division.do?cid=1137869' }
  ],
  gapfs: [
    { name: "Women's Clothing", link: '/browse/division.do?cid=1040941' },
    { name: 'Men’s Clothing', link: '/browse/division.do?cid=1040942' },
    { name: "Girls' Clothing", link: '/browse/division.do?cid=1040943' },
    { name: "Boys' Clothing", link: '/browse/division.do?cid=1079661' },
    { name: "Kid's Clothing", link: '/browse/division.do?cid=1189481' },
    { name: 'Toddler Clothing', link: '/browse/division.do?cid=1091867' },
    { name: 'Baby Clothing', link: '/browse/division.do?cid=1040944' },
  ],
  on: [
    { name: "Women's Clothing", link: '/browse/division.do?cid=5360' },
    { name: "Men's Clothing", link: '/browse/division.do?cid=5155' },
    { name: 'Maternity Clothing', link: '/browse/division.do?cid=5758' },
    { name: "Girls' Clothes", link: '/browse/division.do?cid=6027' },
    { name: "Boys' Clothes", link: '/browse/division.do?cid=5910' },
    { name: 'Toddler Clothing', link: '/browse/division.do?cid=6241' },
    { name: 'Baby Clothing', link: '/browse/division.do?cid=51375' }
  ]
};

export default navLinks;
